import _ from 'lodash';
import enums from '../../common/utils/enums';

export function isUserAPartner(approvals) {
  let registrationApproval = getRegistrationApproval(approvals);
  return registrationApproval
    ? registrationApproval.status === enums.ApprovalStatus.APPROVED
    : false;
}

export function getRegistrationApproval(approvals) {
  return getApproval(approvals, enums.ApprovalTypes.REGISTRATION);
}

export function getServiceAreasApproval(approvals) {
  return getApproval(approvals, enums.ApprovalTypes.SERVICE_AREAS);
}

function getApproval(approvals, type) {
  return _.find(approvals, { type: type });
}

export function getRegistrationApprovalStatus(approvals) {
  let registrationApproval = getRegistrationApproval(approvals);
  return registrationApproval
    ? registrationApproval.status
    : enums.ApprovalStatus.NOT_SUBMITTED;
}

export function getApprovalCommentsIfApplicable(approvals) {
  let registrationApproval = getRegistrationApproval(approvals);
  let isRegistrationInNeedsMoreInfoState = registrationApproval
    ? registrationApproval.status === enums.ApprovalStatus.NEEDS_MORE_INFO
    : false;

  return isRegistrationInNeedsMoreInfoState
    ? registrationApproval.comments
    : '';
}
